export const addWatermarkToImage = async (
    imageFile: File | Blob,
    watermarkText: string
  ): Promise<Blob> => {
    
    return new Promise((resolve, reject) => {
      const img = new Image();
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("Canvas not supported");
  
        canvas.width = img.width;
        canvas.height = img.height;
  
        // First, draw the original image
        ctx.drawImage(img, 0, 0);
  
        // Watermark styling (make it OCR-dominant)
        const fontSize = Math.floor(canvas.width * 0.025); // slightly larger
        ctx.font = `bold ${fontSize}px Arial`;
        ctx.fillStyle = "rgba(151, 151, 151, 0.5)";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
  
        // Calculate spacing
        const textWidth = ctx.measureText(watermarkText).width;
        const stepX = textWidth + 40;
        const stepY = fontSize * 2;
  
        // Rotate canvas for diagonal effect
        ctx.save();
        const angle = (-30 * Math.PI) / 180; // steeper angle to cut across text
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(angle);
        ctx.translate(-canvas.width / 2, -canvas.height / 2);
  
        // Draw watermark densely over image
        for (let x = -canvas.width; x < canvas.width * 2; x += stepX) {
          for (let y = -canvas.height; y < canvas.height * 2; y += stepY) {
            ctx.fillText(watermarkText, x, y);
          }
        }
  
        ctx.restore(); // Done with rotated context
  
        // Export final image as JPEG
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject("Failed to create watermarked image blob");
          },
          "image/jpeg",
          0.8
        );
      };
  
      img.onerror = reject;
      img.src = URL.createObjectURL(imageFile);
    });
  };